<script>
  import Header from 'images/gateways/nalcc/header.png'
</script>

<div>
  <a href="/">
    <h1>
      {window.gettext('Northeast Conservation Planning Atlas')}
    </h1>
  </a>
  <img src={Header} alt={window.gettext('A simple rendering of mountains and water in silhouette.')} />
</div>

<style lang="scss">
  div {
    position: relative;
    height: 106px;
    width: 760px;

    img {
      position: absolute;
      height: 58px;
      width: 100%;
      bottom: 0;
    }

    h1 {
      z-index: 1;
      position: absolute;
      color: #002d4e;
      font-size: $font-size-4;
      font-weight: 700;
      margin: 21px 0 0 17px;
    }
  }
</style>
